import axios from 'axios';

// Create an axios instance with default config
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Fetch suggested questions from the API
 * @returns {Promise<Array>} Array of suggested questions
 */
export const fetchSuggestedQuestions = async () => {
  try {
    const response = await api.get('/echo/llm/suggested-questions');
    return response.data.questions || [];
  } catch (error) {
    console.error('Error fetching suggested questions:', error);
    throw error;
  }
};

/**
 * Submit a query to the API
 * @param {string} query - The user's query
 * @returns {Promise<Object>} Response object with answer and contexts
 */
export const submitQuery = async (query) => {
  try {
    const response = await api.post('/echo/llm/query', { query });
    return response.data;
  } catch (error) {
    console.error('Error submitting query:', error);
    throw error;
  }
};

export default api;
